import { ChakraProvider } from '@chakra-ui/react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'

import store from '@core/app/store/store'
import { ModalProvider } from '@core/utils/contexts/ModalContext/ModalContextProvider'
import { RecaptchaProvider } from '@core/utils/contexts/RecaptchaProvider/RecaptchaProvider'
import { ThemeProvider } from '@core/utils/contexts/ThemeContext/ThemeContext'
import ErrorBoundary from '@core/utils/helpers/errorBoundary'
import '@core/utils/i18n'
import { initSentry } from '@core/utils/sentry/initSentry'
import '../../index.css'

import theme from '../../theme'

import { LoginPage } from './LoginPage'

initSentry()

const router = createBrowserRouter([
    {
        path: process.env.ENV === 'local' ? '' : '/login',
        element: (
            <ErrorBoundary fallback={<div>Something went wrong...</div>}>
                <ThemeProvider>
                    <RecaptchaProvider>
                        <LoginPage />
                    </RecaptchaProvider>
                </ThemeProvider>
            </ErrorBoundary>
        ),
    },
])

const app = document.getElementById('root')
const root = createRoot(app!)
root.render(
    <>
        <Provider store={store}>
            <ChakraProvider theme={theme}>
                <ModalProvider>
                    <RouterProvider router={router} />
                </ModalProvider>
            </ChakraProvider>
        </Provider>
    </>
)
